import PropTypes from 'prop-types';
export const datePropTypes = {
  /**
   * Date of update as a string
   */
  updatedAt: PropTypes.any.isRequired,
  /**
   * Additional className (used by tooltip only!)
   */
  classname: PropTypes.string
};